import React, {Component, ErrorInfo, ReactNode} from "react";

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
    error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
        error: null,
    };

    public static getDerivedStateFromError(error: Error): State {
        return {hasError: true, error};
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    }

    private handleReset = () => {
        this.setState({hasError: false, error: null});
        window.location.href = "/";
    };

    public render() {
        if (this.state.hasError) {
            return (
                <div className="page-container" style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "100vh",
                    textAlign: "center",
                }}>
                    <h1>Došlo je do greške</h1>
                    <p style={{opacity: 0.7, marginBottom: 24}}>
                        Nešto nije u redu. Pokušajte ponovo.
                    </p>
                    <button
                        className="btn-primary"
                        onClick={this.handleReset}
                        style={{maxWidth: 300}}
                    >
                        Vrati se na početnu
                    </button>
                    {process.env.NODE_ENV === "development" && this.state.error && (
                        <details style={{marginTop: 24, textAlign: "left", maxWidth: "100%", overflow: "auto"}}>
                            <summary style={{cursor: "pointer", opacity: 0.6}}>Detalji greške</summary>
                            <pre style={{fontSize: "0.75rem", marginTop: 8}}>
                                {this.state.error.toString()}
                                {this.state.error.stack}
                            </pre>
                        </details>
                    )}
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
